import React, { useEffect } from 'react';
import LazyImage from '../components/LazyImage';

const EventsAndMedia: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <main>
      <section className="breadcrumb-area d-flex align-items-center" style={{backgroundImage: 'url(/images/bg-img/bdrc-bg.jpg)'}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-center">
                <div className="breadcrumb-title">
                  <h2>Events & Media</h2>
                  <div className="breadcrumb-wrap">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Events & Media</li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="services-area pt-70 pb-70 bg-dark" style={{backgroundImage: 'url(/images/bg-1.jpg)', backgroundSize: 'cover'}}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-12">
              <div className="section-title center-align mb-50 text-center">
                <h2>Our Events & Media Gallery</h2>
                <p className="text-white">Discover the vibrant atmosphere and memorable moments at Bangtan Lounge</p>
              </div>
            </div>
          </div>
          <div className="row">
            {[1, 2, 3, 4, 5, 6].map(num => (
              <div key={num} className="col-xl-4 col-md-6 mb-30">
                <div className="single-services">
                  <div className="services-thumb">
                    <a className="gallery-link popup-image" href={`/images/gallary/img${num}.jpg`}>
                      <LazyImage src={`/images/gallary/img${num}.jpg`} alt={`Gallery ${num}`} />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="row mt-50">
            <div className="col-12">
              <div className="section-title center-align mb-50 text-center">
                <h3>Upcoming Events</h3>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-30">
              <div className="event-card bg-dark p-4 rounded">
                <h5 className="text-white">DJ Night</h5>
                <p className="text-white">Every Friday & Saturday</p>
                <p className="text-light">Join us for electrifying DJ nights with the best music and atmosphere</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-30">
              <div className="event-card bg-dark p-4 rounded">
                <h5 className="text-white">Ladies Night</h5>
                <p className="text-white">Every Wednesday</p>
                <p className="text-light">Special offers and entertainment for ladies</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-30">
              <div className="event-card bg-dark p-4 rounded">
                <h5 className="text-white">Live Music</h5>
                <p className="text-white">Selected Weekends</p>
                <p className="text-light">Experience live performances by talented artists</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default EventsAndMedia;